import { TrainingTab } from "@/components/admin/TrainingTab";

export function SettingsTrainingPage() {
  return <TrainingTab />;
}
